export default "__VITE_ASSET__B64FG9RD__"